import $ from "jquery";
import axios from "axios";

const LIKE_ADD_URL = '/rest/forum/topic/like/add';
const LIKE_REMOVE_URL = '/rest/forum/topic/like/remove';

export const forumTopicLikeUpdate = () => {
    $('.topic__like-btn').click(function () {
        event.stopPropagation();
        event.preventDefault();

        const topicId = $(this).data('topic-id');

        $(this).hasClass('comment__like-btn--liked') ?
            removeLike(topicId, $(this)) :
            addLike(topicId, $(this));
    });
}

const addLike = (topicId, element) => {
    axios.get(LIKE_ADD_URL, {
        params: {topicId: topicId}
    })
        .then((response) => {
            element.addClass('comment__like-btn--liked');
            increaseCounter(element.parent());
        });
}

const removeLike = (topicId, element) => {
    axios.get(LIKE_REMOVE_URL, {
        params: {topicId: topicId}
    })
        .then((response) => {
            element.removeClass('comment__like-btn--liked');
            decreaseCounter(element.parent());
        });
}

const increaseCounter = (parent) => {
    let counterElement = parent.find('.comment__like-counter');

    if (counterElement.length) {
        counterElement.text(parseInt(counterElement.text()) + 1);

        return;
    }

    parent.append(`
        <div class="comment__like-counter">1</div>
    `);
}

const decreaseCounter = (parent) => {
    let counterElement = parent.find('.comment__like-counter');

    if (!counterElement.length) {
        return;
    }

    let counterValue = parseInt(counterElement.text()) - 1;

    if (counterValue === 0) {
        counterElement.remove();

        return;
    }

    counterElement.text(counterValue);
}